import { createAsyncThunk } from '@reduxjs/toolkit'
import { OrderPrepare } from '../../api/types'
import { checkout } from '../../api/api'

const checkoutAPI = createAsyncThunk<
  { success: boolean; message: string },
  OrderPrepare,
  { rejectValue: { success: boolean; message: string } }
>('order/checkout', async (data, thunkAPI) => {
  const response = await checkout(data)
  if (!response.data.success) {
    return thunkAPI.rejectWithValue(response.data)
  }
  return response.data
})

export { checkoutAPI }
